import { ContextVariant } from '@anm/components/PreviewInContext';

import { EmbedData } from '../../../../../store/modules/hostedVideo';

export const getActiveEmbedType = (embedData: EmbedData): ContextVariant => {
  if (embedData.type === 'inline') return 'inline';

  return embedData.popover.popoverType;
};
